import * as bootstrap from "bootstrap";
import { injectIcons } from "./icons.js";
import { applyCms } from "./cms/apply.js";
import { initInlineCms } from "./cms/inline.js";
import { initCmsFromServer, refreshAdminSession } from "./cms/store.js";
import { renderHomeCmsContent, bindHomeCmsUi } from "./home-cms.js";

import { initSeo } from "./seo.js";

export async function initSite() {
  await Promise.all([initCmsFromServer(), refreshAdminSession()]);
  renderHomeCmsContent();
  injectIcons();
  applyCms();
  initInlineCms();
  if (document.body.dataset.page !== "home") {
    initSeo();
  }
  initNavScroll();
  initReveal();
  bindHomeCmsUi();
  markActiveNavLink();
  injectMelamediaCredit();
}

function initNavScroll() {
  const nav = document.querySelector(".bm-nav");
  if (!nav) return;

  const updateNav = () => {
    nav.classList.toggle("is-scrolled", window.scrollY > 16);
  };

  updateNav();
  window.addEventListener("scroll", updateNav, { passive: true });

  const menu = document.getElementById("siteMenu");
  if (menu) {
    menu.addEventListener("show.bs.offcanvas", () => {
      nav.classList.add("is-menu-open");
    });
    menu.addEventListener("hidden.bs.offcanvas", () => {
      nav.classList.remove("is-menu-open");
    });
  }
}

let revealObserver;

export function initReveal() {
  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const items = document.querySelectorAll(".reveal:not(.is-visible):not([data-reveal-ready])");

  if (!items.length) return;

  if (prefersReduced) {
    items.forEach((el) => el.classList.add("is-visible"));
    return;
  }

  if (!revealObserver) {
    revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
  }

  items.forEach((el, index) => {
    el.dataset.revealReady = "1";
    el.style.transitionDelay = `${Math.min(index * 60, 360)}ms`;
    revealObserver.observe(el);
  });
}

function markActiveNavLink() {
  const page = document.body.dataset.page;
  if (!page) return;

  document.querySelectorAll(`[data-nav="${page}"]`).forEach((link) => {
    link.classList.add("active");
    link.setAttribute("aria-current", "page");
  });
}

export { bootstrap };

export function getNavOffset() {
  const nav = document.querySelector(".bm-nav");
  return nav?.offsetHeight ?? 72;
}

function injectMelamediaCredit() {
  if (document.body.dataset.page === "admin") return;

  const footer = document.querySelector(".bm-footer");
  if (!footer || footer.querySelector(".bm-powered-by")) return;

  const wrap = document.createElement("div");
  wrap.className = "bm-footer__credit";
  wrap.innerHTML = `
    <a class="bm-powered-by" href="https://mela-media.co.il" target="_blank" rel="noopener noreferrer">
      נבנה ע״י <strong>MelaMedia</strong>
    </a>
  `;
  footer.appendChild(wrap);
}
